<script setup lang="ts">
import { selected } from '.'

import Active from '@/container/components/filters/bricks/components/Active.vue'
import Choice from '@/container/components/filters/bricks/components/Choice.vue'

import type { Form } from '@/services/form'
import type { CanvasOptions, RulesSet } from '=/types'

const show = defineModel<boolean>('show', { required: true })
const values = defineModel<Form<CanvasOptions>>('values', { required: true })

defineProps<{ rules?: RulesSet }>()
</script>

<template>
  <Active v-model:show="show" v-model:values="values" v-model:selected="selected" />
  <hr />
  <Choice v-model:show="show" v-model:values="values" v-model:selected="selected" :rules />
</template>

<style lang="scss">
.item.selected {
  position: relative;
  border-radius: 8px;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    box-shadow:
      inset 0 0 0 2px var(--accent),
      inset 0 0 0 4px white;
    pointer-events: none;
  }

  &.new::after {
    box-shadow: inset 0 0 0 2px var(--border);
  }
}
</style>
